import { measure } from '@/components/Analytics/Analytics';
import Video from '@/components/Video/Video';
import { SpeciesAttributes, StrapiEntry } from '@/lib/apiTypes';
import { motion, useReducedMotion } from 'framer-motion';
import { FC } from 'react';

const Vlog: FC<{
	species: StrapiEntry<SpeciesAttributes>;
}> = ({ species }) => {
	const reduceMotion = useReducedMotion();

	return (
		<>
			{species.attributes.videoMain && (
				<motion.div
					className="pb-3 pt-4"
					initial={{
						opacity: 0,
						scale: reduceMotion ? 1 : 0.9,
					}}
					animate={{
						opacity: 1,
						scale: 1,
						transition: {
							delay: 0.2,
						},
					}}>
					<Video
						video={species.attributes.videoMain}
						onPlay={() => {
							measure(
								`species-video-view-${species.id}-${species.attributes.slug}`,
							);
						}}
					/>
				</motion.div>
			)}
		</>
	);
};

export default Vlog;
